import { AddressDetailsT } from './AddressDetailsT'
import { JobRecordT } from './Job'
export interface LocationT {
    latitude: number
    longitude: number
}
export interface CoordinateT {
    longitude: number
    latitude: number
}

export interface UserLocationT {
    latitude: number
    longitude: number
}

export type CapabilityT = {
    [key in string]: boolean;
}


export interface UserT {
    id: number
    address: string
    address2: string
    addressDetails: AddressDetailsT
    companyName?: string
    email: string
    firstName: string
    isCompany: boolean
    lastName: string
    phone: string
    profilePic: string
    location?: LocationT
    roles?: Array<string>
    isSales?: boolean
    salesSchedule?: Array<any>
    defaultCompany?: number
    fk_companies?: Array<number>
    hourlyRate?: number
    jobs?: Array<JobRecordT>
    primaryCard?: number
    viewFinancials?: boolean
    capabilities?: CapabilityT
    extra_capabilities?: CapabilityT
    companies?: Array<{
        id: number
        name: string
        isDefault?: boolean
    }>
}

export const initUserLocationObj: UserLocationT = {
    latitude: 0,
    longitude: 0
}

export const initUserObj: UserT = {
    id: 0,
    address: '',
    address2: '',
    addressDetails: {
        "address": "",
        "latitude": "",
        "longitude": "",
        "country": "",
        "state": "",
        "city": "",
        "address_line_one": "",
        "address_line_two": "",
        "zipcode": "",
    },
    companyName: '',
    email: '',
    firstName: '',
    isCompany: false,
    lastName: '',
    phone: '',
    profilePic: '',
    location: initUserLocationObj,
    roles: [],
    // capabilities: {
    //     'read': true,
    //     'upload_files': true,
    // }

}


export interface ClientT extends UserT {
    cards?: Array<{
        cardName: string
        cardKey: string
        cardType: string
        last4: string
    }>
    clientJobs?: Array<number>
}



export interface BillingContactT {
    id: number
    address: string
    address2: string
    companyName?: string
    email: string
    firstName: string
    isCompany: boolean
    lastName: string
    phone: string
    profilePic: string
}


export const BillingContactObj: BillingContactT = {
    id: null,
    address: '',
    address2: '',
    companyName: '',
    email: '',
    firstName: '',
    isCompany: false,
    lastName: '',
    phone: '',
    profilePic: ''
}




export const ClientObj: ClientT = {
    id: null,
    address: '',
    address2: '',
    addressDetails: {
        "address": "",
        "latitude": "",
        "longitude": "",
        "country": "",
        "state": "",
        "city": "",
        "address_line_one": "",
        "address_line_two": "",
        "zipcode": "",
    },
    companyName: '',
    email: '',
    firstName: '',
    isCompany: false,
    lastName: '',
    phone: '',
    profilePic: ''
}
